import React from 'react';


export const CloudFront = props => {
    return (
        <svg className={props.className} width="308" height="308" viewBox="0 0 308 308" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M192.01 127.465L251.212 121.151L281.888 127.52L281.999 127.588L225.441 130.962L191.957 127.52L192.01 127.465Z"
                fill="#5E1F18"/>
            <path
                d="M191.958 127.521L251.162 122.896L251.569 122.303L251.571 49.2588L251.164 48.4238L191.958 63.8208V127.521Z"
                fill="#8C3123"/>
            <path d="M282 127.59L251.162 122.896L251.164 48.4238L281.999 63.8518L282 127.59Z" fill="#E05243"/>
            <path
                d="M191.958 180.115L192.823 180.721L251.172 184.68L280.944 180.721L281.999 180.142L225.442 176.667L191.958 180.115Z"
                fill="#F2B0A9"/>
            <path
                d="M191.958 180.115L251.172 184.52L251.355 184.766L251.31 258.708L251.164 259.094L191.958 243.819V180.115Z"
                fill="#8C3123"/>
            <path d="M281.999 180.142L251.172 184.52L251.164 259.094L281.999 243.785V180.142Z" fill="#E05243"/>
            <path
                d="M115.119 127.408L56.5886 122.394L26.195 127.439L26.002 127.59L82.559 130.964L115.433 127.588L115.119 127.408Z"
                fill="#5E1F18"/>
            <path d="M26.002 127.59L56.559 123.116L57.458 122.479V49.2788L56.559 48.4238L26.002 63.8548V127.59Z"
                  fill="#8C3123"/>
            <path d="M115.433 127.588L56.5586 123.116V48.4238L115.436 63.8208L115.433 127.588Z" fill="#E05243"/>
            <path
                d="M115.433 180.142L114.082 181.127L56.559 185.44L26.976 181.127L26 180.142L82.559 176.667L115.433 180.142Z"
                fill="#F2B0A9"/>
            <path d="M26 180.142L56.558 184.482L57.335 185.434L57.418 257.767L56.559 259.094L26.002 243.785L26 180.142Z"
                  fill="#8C3123"/>
            <path d="M115.433 180.142L56.5576 184.482L56.5586 259.094L115.433 243.819V180.142Z" fill="#E05243"/>
            <path
                d="M215.104 189.66L154.001 183.634L92.2891 189.661L93.1591 190.396L153.7 200.013L214.233 190.396L215.104 189.66Z"
                fill="#F2B0A9"/>
            <path
                d="M92.2891 189.661L153.7 198.659L154.323 199.492L154.402 306.451L153.7 307.637L92.2891 276.931V189.661Z"
                fill="#8C3123"/>
            <path d="M215.104 189.66L153.7 198.659V307.637L215.105 276.931L215.104 189.66Z" fill="#E05243"/>
            <path
                d="M154.001 123.933L92.2891 117.975L92.4481 117.884L153.697 108.382L214.919 117.906L215.105 117.975L154.001 123.933Z"
                fill="#5E1F18"/>
            <path d="M92.2891 117.975L153.7 109.026L153.994 108.758L153.858 0.165L153.7 0L92.2891 30.709V117.975Z"
                  fill="#8C3123"/>
            <path d="M215.105 117.975L153.7 109.026V0L215.105 30.709V117.975Z" fill="#E05243"/>
        </svg>
    )

};
